module.exports = __webpack_public_path__ + "img/m_role_2_name.7b16d1a5.png";